var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhotoPassport(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9904 6.43066H20.5269C21.7696 6.43066 22.7769 7.43791 22.7769 8.68066V19.1807C22.7769 19.7777 22.5399 20.3499 22.1176 20.7714C21.6961 21.1937 21.1239 21.4307 20.5269 21.4307H4.02686C3.42986 21.4307 2.85761 21.1937 2.43611 20.7714C2.01386 20.3499 1.77686 19.7777 1.77686 19.1807V8.68066C1.77686 7.43791 2.78411 6.43066 4.02686 6.43066H6.56336L7.44161 4.67417C7.82261 3.91217 8.60186 3.43066 9.45386 3.43066H15.0999C15.9519 3.43066 16.7311 3.91217 17.1121 4.67417L17.9904 6.43066ZM12.2769 7.93066C9.37961 7.93066 7.02686 10.2834 7.02686 13.1807C7.02686 16.0779 9.37961 18.4307 12.2769 18.4307C15.1741 18.4307 17.5269 16.0779 17.5269 13.1807C17.5269 10.2834 15.1741 7.93066 12.2769 7.93066ZM12.2769 9.43066C14.3469 9.43066 16.0269 11.1107 16.0269 13.1807C16.0269 15.2507 14.3469 16.9307 12.2769 16.9307C10.2069 16.9307 8.52686 15.2507 8.52686 13.1807C8.52686 11.1107 10.2069 9.43066 12.2769 9.43066Z",
    fill: "url(#paint0_linear_3239_13415)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3239_13415",
    x1: 12.2769,
    y1: 3.43066,
    x2: 12.2769,
    y2: 21.4307,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#466AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#06B8FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotoPassport);
export default __webpack_public_path__ + "static/media/photo_passport.0ad9152905b512b2a4d3cc3cc38d5fd9.svg";
export { ForwardRef as ReactComponent };